/* =========================================================
   SEXYSHOES | Searchanise Collection Slick v9 DESKTOP + MOBILE
   All images stay in Slick
   Native Searchanise image-src sync only
   No color/alt matching
   No swatch active-class changes
   Desktop arrows enabled for styling
   ========================================================= */

(function ssCollectionSlickV9Boot() {
  'use strict';

  var TEST_FIRST_CARD_ONLY = false;
  var INIT_CLASS = 'ss-slick-v9-init';
  var VIEWER_CLASS = 'ss-slick-v9-viewer';
  var MAX_CARD_READY_TRIES = 50;
  var CARD_READY_DELAY = 150;

  function startWhenReady() {
    if (!window.Searchanise || !window.Searchanise.$) {
      setTimeout(startWhenReady, 150);
      return;
    }

    var $ = window.Searchanise.$;
    window.jQuery = $;

    if (window._ssSlickV9Started) {
      scheduleInit(document);
      return;
    }

    window._ssSlickV9Started = true;

    function isCollectionPage() {
      return window.location.pathname.indexOf('/collections/') !== -1;
    }

    function isMobileViewport() {
      return window.innerWidth <= 768;
    }

    function normalizeImage(src) {
      if (!src) return '';

      return String(src)
        .replace(/^https?:/, '')
        .replace(/(_\d+x\d+|_\d+x|_x\d+|_small|_medium|_large|_grande|_compact|_master)(?=\.)/i, '')
        .split('?')[0]
        .trim();
    }

    function getProductData(card) {
      return $(card).data('snize_item_data');
    }

    function getNativeImage(card) {
      return card.querySelector('.snize-item-image');
    }

    function getNativeImageSrc(card) {
      var img = getNativeImage(card);
      if (!img) return '';

      return (
        img.getAttribute('src') ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.getAttribute('data-snize-src') ||
        ''
      );
    }

    function getSlideImageSrc(img) {
      return (
        img.getAttribute('src') ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        ''
      );
    }

    function cardIsReady(card) {
      var data = getProductData(card);

      if (!card) return false;
      if (!card.querySelector('.snize-thumbnail-wrapper')) return false;
      if (!getNativeImage(card)) return false;
      if (!data) return false;
      if (!data.shopify_images || !data.shopify_images.length) return false;

      return true;
    }

function loadSlick(callback) {
  function slickIsReady() {
    return !!($ && $.fn && typeof $.fn.slick === 'function');
  }

  function waitForSlick(attempt) {
    attempt = attempt || 0;

    if (slickIsReady()) {
      window._ssSlickV9Loading = false;
      callback();
      return;
    }

    if (attempt >= 50) {
      window._ssSlickV9Loading = false;
      console.warn('SEXYSHOES Slick v9: Slick failed to attach to Searchanise jQuery.');
      return;
    }

    setTimeout(function () {
      waitForSlick(attempt + 1);
    }, 100);
  }

  if (slickIsReady()) {
    callback();
    return;
  }

  if (window._ssSlickV9Loading) {
    waitForSlick(0);
    return;
  }

  window._ssSlickV9Loading = true;

  var existingScript = document.querySelector(
    'script[src*="slick-carousel"][src*="slick.min.js"]'
  );

  if (existingScript) {
    waitForSlick(0);
    return;
  }

  var script = document.createElement('script');
  script.src =
    'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';

  script.onload = function () {
    waitForSlick(0);
  };

  script.onerror = function () {
    window._ssSlickV9Loading = false;
    console.error('SEXYSHOES Slick v9: Failed to load slick.min.js.');
  };

  document.head.appendChild(script);
}

    function destroyViewer(card) {
      var existing = card.querySelector('.' + VIEWER_CLASS);

      if (existing) {
        try {
          if ($(existing).hasClass('slick-initialized')) {
            $(existing).slick('unslick');
          }
        } catch (e) {}

        existing.remove();
      }

      card.classList.remove(INIT_CLASS);

      if (card._ssSlickV9Observer) {
        try {
          card._ssSlickV9Observer.disconnect();
        } catch (e2) {}

        card._ssSlickV9Observer = null;
      }

      if (card._ssSlickV9ResetObserver) {
        try {
          card._ssSlickV9ResetObserver.disconnect();
        } catch (e3) {}
        card._ssSlickV9ResetObserver = null;
      }
    }

    function goToNativeImage(card, viewer) {
      if (!viewer || !$(viewer).hasClass('slick-initialized')) return;

      var nativeSrc = normalizeImage(getNativeImageSrc(card));
      if (!nativeSrc) return;

      var targetIndex = -1;

      $(viewer).find('.slick-slide:not(.slick-cloned) img').each(function () {
        if (targetIndex !== -1) return;

        var slideSrc = normalizeImage(getSlideImageSrc(this));

        if (
          slideSrc === nativeSrc ||
          slideSrc.indexOf(nativeSrc) !== -1 ||
          nativeSrc.indexOf(slideSrc) !== -1
        ) {
          targetIndex = Number($(this).closest('.slick-slide').attr('data-slick-index'));
        }
      });

      if (targetIndex >= 0) {
        $(viewer).slick('slickGoTo', targetIndex, true);
      }
    }

    function resetSwatchToDefault(card) {
      card.querySelectorAll('.snize-color-swatch, .snize-color-swatch-box a').forEach(function(el) {
        el.classList.remove('ss-snize-active-swatch');
        el.classList.remove('snize-color-swatch-active');
      });
      var firstSwatch = card.querySelector('.snize-color-swatch-box .snize-color-swatch, .snize-color-swatch-box a');
      if (firstSwatch) firstSwatch.classList.add('ss-snize-active-swatch');
    }

    function observeNativeImage(card, viewer) {
      if (card._ssSlickV9Observer) return;

      var nativeImg = getNativeImage(card);
      if (!nativeImg) return;

      var lastSrc = normalizeImage(getNativeImageSrc(card));

      var observer = new MutationObserver(function () {
        var currentSrc = normalizeImage(getNativeImageSrc(card));
        if (!currentSrc || currentSrc === lastSrc) return;

        lastSrc = currentSrc;

        setTimeout(function () {
          goToNativeImage(card, viewer);
        }, 80);
      });

      observer.observe(nativeImg, {
        attributes: true,
        attributeFilter: [
          'src',
          'data-src',
          'data-original',
          'data-snize-src',
          'srcset'
        ]
      });

      card._ssSlickV9Observer = observer;
    }

    function buildViewer(card) {
      if (!cardIsReady(card)) return;

      var productData = getProductData(card);
      if (!productData || !productData.shopify_images || productData.shopify_images.length < 2) {
        return;
      }

      var currentViewer = card.querySelector('.' + VIEWER_CLASS);

      if (currentViewer && $(currentViewer).hasClass('slick-initialized')) {
        $(currentViewer).slick('setPosition');
        //goToNativeImage(card, currentViewer);
        return;
      }

      destroyViewer(card);

      var wrapper = card.querySelector('.snize-thumbnail-wrapper');
      if (!wrapper) return;

      var viewer = document.createElement('div');
      viewer.className =
        'ss-slick-v5-viewer ss-slick-v6-viewer ss-slick-v8-viewer ss-slick-v9-viewer ' +
        (isMobileViewport() ? 'ss-slick-v9-mobile' : 'ss-slick-v9-desktop');

      productData.shopify_images.forEach(function (img) {
        var slide = document.createElement('div');
        slide.className = 'ss-slick-v5-slide ss-slick-v6-slide ss-slick-v8-slide ss-slick-v9-slide';

        var image = document.createElement('img');
        image.src = img;
        image.alt = '';

        slide.appendChild(image);
        viewer.appendChild(slide);
      });

      wrapper.appendChild(viewer);

      wrapper.classList.add(
        'ss-slick-v5-ready',
        'ss-slick-v6-ready',
        'ss-slick-v8-ready',
        'ss-slick-v9-ready'
      );

      card.classList.add(INIT_CLASS);

      $(viewer).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: !isMobileViewport(),
        dots: isMobileViewport(),
        fade: false,
        speed: 250,
        adaptiveHeight: false,
        swipe: true,
        draggable: true,
        touchMove: true,
        waitForAnimate: false,
        prevArrow: '<button type="button" class="slick-prev ss-slick-v9-arrow" onclick="event.preventDefault();event.stopPropagation();return false;" aria-label="Previous image"></button>',
        nextArrow: '<button type="button" class="slick-next ss-slick-v9-arrow" onclick="event.preventDefault();event.stopPropagation();return false;" aria-label="Next image"></button>'
      });

      $(viewer).addClass('ss-slick-v9-mounted');
            $(viewer).on('afterChange', function () {
        clearTimeout(card._ssSlickV9ReturnTimer);

        card._ssSlickV9ReturnTimer = setTimeout(function () {
          if (!$(viewer).hasClass('slick-initialized')) return;

          var rect = card.getBoundingClientRect();
          var cardAboveViewport = rect.bottom < 120;
          var cardMostlyBelowViewport = rect.top > window.innerHeight - 120;

          if (cardAboveViewport || cardMostlyBelowViewport) {
            $(viewer).slick('slickGoTo', 0, true);
          }
        }, 1200);
      });

        setTimeout(function () {
        if ($(viewer).hasClass('slick-initialized')) {
          $(viewer).slick('setPosition');
          $(viewer).find('ul.slick-dots').css('display', 'flex');
        }
      }, 150);

      setTimeout(function () {
        if ($(viewer).hasClass('slick-initialized')) {
          $(viewer).slick('setPosition');
          $(viewer).find('ul.slick-dots').css('display', 'flex');
        }
      }, 600);

      observeNativeImage(card, viewer);

      var resetObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            if ($(viewer).hasClass('slick-initialized')) {
              $(viewer).slick('slickGoTo', 0, true);
            }
            resetSwatchToDefault(card);
          }
        });
      }, {
        threshold: 0
      });

      resetObserver.observe(card);
      card._ssSlickV9ResetObserver = resetObserver;
    }

/* =========================================================
   SEXYSHOES NOTE 09-14-2026
   SEARCHANISE SLICK v9 CARD INIT LOCK

   Purpose:
   - Prevent multiple Slick initialization chains from running
     against the same Searchanise product card at the same time.
   - Searchanise can fire multiple ResultsUpdated / DOM events
     while collection cards are still being rendered.
   - scheduleInit() also runs multiple delayed initialization passes.
   - Without a per-card lock, several waitForCardReady() chains can
     reach buildViewer() for the same card and rebuild/destroy the
     same Slick viewer during first-load rendering.
   - This can cause intermittent missing sliders/images and
     inconsistent rendered collection state.

   IMPORTANT:
   - Does NOT change Searchanise product URLs.
   - Does NOT change collection context or PDP breadcrumbs.
   - Does NOT change Quick Add, swatches, mobile dots, desktop arrows,
     product image data, SchemaPlus, or Searchanise result order.
   - Only allows ONE Slick initialization chain per card at a time.
   ========================================================= */

function waitForCardReady(card, callback, attempt) {
  attempt = attempt || 0;

  if (!card) return;

  /* Only allow one initialization chain per card */
  if (attempt === 0) {
    if (card._ssSlickV9Pending) return;
    card._ssSlickV9Pending = true;
  }

  if (cardIsReady(card)) {
    loadSlick(function () {
      buildViewer(card);

      card._ssSlickV9Pending = false;

      if (typeof callback === 'function') callback();
    });
    return;
  }

  if (attempt >= MAX_CARD_READY_TRIES) {
    card._ssSlickV9Pending = false;
    return;
  }

  setTimeout(function () {
    waitForCardReady(card, callback, attempt + 1);
  }, CARD_READY_DELAY);
}

    function bindGlobalSwatches() {
      if (window._ssSlickV9GlobalSwatchBound) return;
      window._ssSlickV9GlobalSwatchBound = true;

      document.addEventListener('click', function (event) {
        var swatch = event.target.closest('.snize-color-swatch');
        if (!swatch) return;

        var card = swatch.closest('.snize-product');
        if (!card) return;

        card.querySelectorAll('.snize-color-swatch, .snize-color-swatch-box a').forEach(function(el) {
          el.classList.remove('ss-snize-active-swatch');
          el.classList.remove('snize-color-swatch-active');
        });
        swatch.classList.add('ss-snize-active-swatch');

        waitForCardReady(card, function () {
          var viewer = card.querySelector('.' + VIEWER_CLASS);
          if (!viewer) return;

          setTimeout(function () {
            goToNativeImage(card, viewer);
          }, 120);

          setTimeout(function () {
            goToNativeImage(card, viewer);
          }, 300);

          setTimeout(function () {
            goToNativeImage(card, viewer);
          }, 650);
        });
      }, false);
    }

    function init(container) {
      if (!isCollectionPage()) return;

      var cards = $('.snize-product', container || document).toArray();
      if (!cards.length) return;

      bindGlobalSwatches();

      var targetCards = TEST_FIRST_CARD_ONLY ? [cards[0]] : cards;

      targetCards.forEach(function (card) {
        waitForCardReady(card, function () {});
      });
    }

    function scheduleInit(container) {
      setTimeout(function () { init(container || document); }, 250);
      setTimeout(function () { init(container || document); }, 1000);
      setTimeout(function () { init(container || document); }, 2500);
    }

    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      scheduleInit(container || document);
    });

    document.addEventListener('Searchanise.ResultsUpdated', function () {
      scheduleInit(document);
    });

    window.addEventListener('pageshow', function () {
      scheduleInit(document);
    });

    scheduleInit(document);

    var gridObserverTimer = null;

    var gridObserver = new MutationObserver(function (mutations) {
      var shouldRun = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (
            (node.classList && node.classList.contains('snize-product')) ||
            (node.querySelector && node.querySelector('.snize-product'))
          ) {
            shouldRun = true;
          }
        });
      });

      if (!shouldRun) return;

      clearTimeout(gridObserverTimer);

      gridObserverTimer = setTimeout(function () {
        init(document);
      }, 400);
    });

    gridObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('Searchanise.Loaded', startWhenReady);
  document.addEventListener('Searchanise.ResultsUpdated', startWhenReady);

  window.addEventListener('load', function () {
    setTimeout(startWhenReady, 750);
    setTimeout(startWhenReady, 2000);
  });

  startWhenReady();
})();